import { codeEditorTyping } from '../editor-typing.generated';
import { AutomationControlCodeActionEnum } from './control-code-action.enum';

export const controlCodeEditorTyping = codeEditorTyping(
  AutomationControlCodeActionEnum,
);
